import { useState, useEffect, useMemo } from 'react';
import { Header } from './Views/Header/Header';
import { Card } from 'components/Cards/card/card';
import SharepointLink from 'components/Global/SharepointLink/SharepointLink';
import { FormURL } from 'components/Global/FormURL/FormURL';
import { useLocation } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import { create } from 'zustand';
import './Product-Toolkits.scss';
import { Link, Navigate } from 'react-router-dom';
import { useUser } from 'context/UserContext';
import { useQuery } from '@tanstack/react-query';
import { GenerateSSILink } from '../../../../api/software';
import CircularProgress from '@mui/material/CircularProgress';

import { GetSoftwareListByProduct } from '../../../../api/software';
import { GetNewsListByProduct } from '../../../../api/news';
import { GetProductList, GetProductToolkitByCatAndDivList } from '../../../../api/product';
import { GetAppPackageProductByProductID } from '../../../../api/contentmanagement';
import FASTLink from '../../../../components/FASTLogineApp/FASTLink';

export const toolkitStore = create((set) => ({
  product: null,
  productIndex: 0,
  setProductIndex: (indexInput) => set({ productIndex: indexInput }),
  setProduct: (productInput) => set({ product: productInput }),
}));

const useToolkitStore = toolkitStore;

const getProductGroupFromURL = () => {
  let url = window.location.pathname.split('/');
  return url[3];
};

function Index() {
  const user = useUser();
  const setProduct = useToolkitStore((state) => state.setProduct);
  const product = useToolkitStore((state) => state.product);
  const productIndex = useToolkitStore((state) => state.productIndex);
  const setProductIndex = useToolkitStore((state) => state.setProductIndex);
  const [productDetails, setProductDetails] = useState(undefined);
  let location = useLocation();

  function sortProducts(data) {
    data.sort((a, b) => (a.underwritten < b.underwritten ? 1 : -1));
    return data;
  }

  const getProductListQuery = useQuery({
    queryKey: ['productList', getProductGroupFromURL()],
    queryFn: () => GetProductList({ ProductID: getProductGroupFromURL() })(),
    enabled: false,
  });

  useEffect(() => {
    if (getProductListQuery.isSuccess && getProductListQuery.data) {
      setProductDetails(sortProducts(JSON.parse(getProductListQuery.data)));
    }
  }, [getProductListQuery.isSuccess, getProductListQuery.data]);

  function checkLOB(iD3Code) {
    var isValid = user.LOB.find((o) => o.ProductCode == iD3Code);
    return isValid != null && isValid != undefined;
  }

  if (!checkLOB(getProductGroupFromURL())) {
    return <Navigate to={`/Error/AccessDenied?requested=${location.pathname}`} />;
  }

  const appPackageLinkQuery = useQuery({
    queryKey: [
      'GetAppPackageProductByProductID',
      productDetails != null && productDetails != undefined ? productDetails[productIndex].ID : 0,
    ],
    queryFn: () =>
      GetAppPackageProductByProductID({
        ID:
          productDetails != null && productDetails != undefined
            ? productDetails[productIndex].ID
            : 0,
      })(),
  });

  function GetAppPackageLinkUrl(link) {
    let pkge = 'CareerPackage';

    switch (link.divisionID) {
      case 0:
        pkge = user.division == 'ISD' ? 'ISDPackage' : 'CareerPackage';
        break;
      case 1:
        pkge = 'CareerPackage';
        break;
      case 2:
        pkge = 'ISDPackage';
        break;
    }

    return '/Applications/AppPackage/' + pkge + '?productid=' + link.appPackageProductID;
  }

  const appPackageElement = () => {
    let lst = [];

    if (
      appPackageLinkQuery.data != null &&
      appPackageLinkQuery.data != undefined &&
      appPackageLinkQuery.data.length > 0
    ) {
      for (var i = 0; i < appPackageLinkQuery.data.length; i++) {
        lst.push(
          <li>
            <a
              href={GetAppPackageLinkUrl(appPackageLinkQuery.data[i])}
              target="_blank"
              rel="noreferrer"
            >
              {appPackageLinkQuery.data[i].linkName}
            </a>
          </li>
        );
      }
    }

    return lst;
  };

  useEffect(() => {
    setProduct(getProductGroupFromURL());
    setProductIndex(0);
    getProductListQuery.refetch();
    return () => setProduct(null);
  }, [location]);

  function getBackgroundColor() {
    let defaultColor = '#3167B080';

    if (productDetails != undefined || productDetails != null) {
      defaultColor = productDetails[productIndex].BaseColorCss + '80';
    }

    return defaultColor;
  }

  return (
    <div className="page-wrapper">
      <div className="row mb-5 pl-3 pr-3" id="toolkit-header">
        <Header productDetails={productDetails} />
      </div>
      <div className="row d-flex justify-content-center">
        <div className="col-12 col-lg-6 mb-2">
          <Card
            title="Forms"
            height="15rem"
            headingBgColor={getBackgroundColor()} //"#9FCF57"
            headingFontColor="black"
            headingFontWeight="400"
            headingHeight="3rem"
            width="100%"
          >
            <FormItems
              productDetails={productDetails}
              appPackageElement={appPackageElement()}
              productIndex={productIndex}
            />
          </Card>
        </div>
        <div className="col-12 col-lg-6 mb-2">
          <Card
            opacity={0.5}
            title="Applications"
            headingBgColor={getBackgroundColor()} //"#B72071"
            headingHeight="3rem"
            headingFontColor="black"
            headingFontWeight="400"
            height="15rem"
            width="100%"
          >
            <SoftwareItems
              baseProductID={
                productDetails ? productDetails[productIndex].BaseProductId : undefined
              }
              //SSILink={SSILink}
            />
          </Card>
        </div>
        <div className="col-12 col-lg-6 mb-2">
          <Card
            title="News"
            headingBgColor={getBackgroundColor()} //"#EBA91F"
            headingHeight="3rem"
            headingFontColor="black"
            headingFontWeight="400"
            height="25rem"
            width="100%"
          >
            <NewsItems
              baseProductID={
                productDetails ? productDetails[productIndex].BaseProductId : undefined
              }
            />
          </Card>
        </div>
        <div className="col-12 col-lg-6 mb-2">
          <Card
            title="Training"
            headingBgColor={getBackgroundColor()} //"#ED4E39"
            headingHeight="3rem"
            headingFontColor="black"
            headingFontWeight="400"
            height="25rem"
            width="100%"
          >
            <TrainingItems
              baseProductID={
                productDetails ? productDetails[productIndex].BaseProductId : undefined
              }
            />
          </Card>
        </div>
      </div>
    </div>
  );
}

function SoftwareItems(props) {
  const user = useUser();
  let routePrefix = 'Applications';

  const getSoftwareListQuery = useQuery({
    queryKey: ['GetSoftwareList', props.baseProductID],
    queryFn: () => GetSoftwareListByProduct({ Division: '', Product: props.baseProductID })(),
    enabled: false,
  });

  const data = useMemo(() => {
    if (getSoftwareListQuery.isSuccess && getSoftwareListQuery.data) {
      return JSON.parse(getSoftwareListQuery.data);
    }
    return [];
  }, [getSoftwareListQuery.data]);

  useEffect(() => {
    if (props.baseProductID !== undefined) {
      getSoftwareListQuery.refetch();
    }
  }, [props.baseProductID]);

  if (
    getSoftwareListQuery.isFetching ||
    getSoftwareListQuery.isPending ||
    props.baseProductID === undefined /* || !props.SSILink*/
  ) {
    return (
      <>
        <ListSkeleton />
      </>
    );
  } else if (!data.length || data.length == 0) {
    return (
      <>
        <h6 className="no-items">No software items available.</h6>
      </>
    );
  } else {
    return (
      <>
        <ul>
          {data.map((SoftwareItem) => {
            let elements = [];
            switch (SoftwareItem.Title) {
              case 'Secure Solutions Illustrator (Web Version)':
                elements.push(
                  <SSILink
                    key={SoftwareItem.Title}
                    id="SSI"
                    label="Secure Solutions Illustrator (SSI)"
                  />
                );
                break;
              // case 'Do Not Call':
              //   elements.push(
              //     <li key={SoftwareItem.Title}>
              //       <Link to={{ pathname: '/' + routePrefix + '/DoNotCall' }}>
              //         {SoftwareItem.Title}
              //       </Link>
              //     </li>
              //   );
              //   break;
              case 'Benefits Solution Proposal':
                if (user.permissions.WPM)
                  elements.push(
                    <li key={SoftwareItem.Title}>
                      <Link to={{ pathname: '/' + routePrefix + '/BenefitsSolutionProposal' }}>
                        {SoftwareItem.Title}
                      </Link>
                    </li>
                  );
                break;
              case 'Annuities, Generation Legacy, Lifetime Navigator - ULSG, Term, Whole Life':
                elements.push(
                  <SSILink
                    key={SoftwareItem.Title}
                    id="Annuities-Product-Toolkit"
                    label="Annuities, Generation Legacy, Lifetime Navigator - ULSG, Term, Whole Life"
                  />
                );
                break;
              case 'iProvide INSpeed Plus eApp':
                elements.push(<FASTLink key={SoftwareItem.Title} id="FAST-iProvide" />);
                break;
              case 'IQumulate eApplication':
                elements.push(
                  <FASTLink
                    key={SoftwareItem.Title}
                    id="FAST-IQumulate"
                    name="IQumulate eApplication"
                  />
                );
                break;
              default:
                elements.push(
                  <li key={SoftwareItem.Title}>
                    <SharepointLink
                      baseUrl={`${process.env.REACT_APP_AGENTPORTAL_PREFIX}/${routePrefix}`}
                      linkType={SoftwareItem.LinkTypeID}
                      link={SoftwareItem.Url}
                    >
                      {SoftwareItem.Title}
                    </SharepointLink>
                  </li>
                );
                break;
            }

            return elements;
          })}
        </ul>
      </>
    );
  }
}

function SSILink({ ...props }) {
  const [ssiData, setSSIData] = useState(null);
  const SSIURL = useQuery({
    queryKey: ['SSILink', props.id],
    queryFn: () => GenerateSSILink({ azureID: '', envInput: '' })(),
    enabled: false,
    gcTime: 0,
  });

  useEffect(() => {
    if (SSIURL.isSuccess && SSIURL.data) {
      setSSIData(SSIURL.data);
    }
  }, [SSIURL.isSuccess, SSIURL.data]);

  const [errorTimer, setErrorTimer] = useState(false);

  useEffect(() => {
    if (ssiData?.postBackUrl) {
      document.forms['frmSSI' + props.id].submit();
    }
  }, [SSIURL.data]);

  useEffect(() => {
    if (SSIURL.isError) {
      setTimeout(() => {
        setErrorTimer(true);
      }, 3000);
    }
  }, [SSIURL.isError]);

  const openSSIURL = () => {
    SSIURL.refetch();
  };

  if (SSIURL.isError && !SSIURL.isFetching) {
    if (errorTimer) {
      return (
        <li>
          <a
            onClick={() => {
              openSSIURL();
            }}
          >
            Click to retry
          </a>
        </li>
      );
    }
    return (
      <li>
        <a>Could not generate SSI Link</a>
      </li>
    );
  }

  return (
    <li>
      <a
        className="d-flex justify-content-between align-items-center"
        onClick={() => {
          openSSIURL();
        }}
      >
        {props.label}
        {SSIURL.isFetching && <CircularProgress size={16} />}
      </a>
      {SSIURL && (
        <form action={ssiData?.postBackUrl} id={'frmSSI' + props.id} target="_blank" method="POST">
          <input
            type="hidden"
            id="SAMLResponse"
            name="SAMLResponse"
            value={ssiData?.samlResponse}
          />
          <input type="hidden" id="RelayState" name="RelayState" value={ssiData?.relayUrl} />
        </form>
      )}
    </li>
  );
}

function NewsItems(props) {
  const getNewsByProductQuery = useQuery({
    queryKey: ['getNewsByProduct', props.baseProductID],
    queryFn: () => GetNewsListByProduct({ Division: '', Product: props.baseProductID })(),
    enabled: false,
  });

  const data = useMemo(() => {
    if (getNewsByProductQuery.isSuccess && getNewsByProductQuery.data) {
      return getNewsByProductQuery.data;
    }
    return [];
  }, [getNewsByProductQuery.data]);

  useEffect(() => {
    if (props.baseProductID !== undefined) {
      getNewsByProductQuery.refetch();
    }
  }, [props.baseProductID]);

  if (
    getNewsByProductQuery.isFetching ||
    getNewsByProductQuery.isPending ||
    props.baseProductID === undefined
  ) {
    return (
      <>
        <ListSkeleton />
      </>
    );
  } else if (!data.length || data.length == 0) {
    return (
      <>
        <h6 className="no-items">No news items available.</h6>
      </>
    );
  } else {
    return (
      <>
        <ul>
          {data.map((newsItem) => (
            <li key={newsItem.title}>
              <SharepointLink
                linkType={newsItem.linkTypeID}
                link={newsItem.documentLink}
                baseUrl={`${process.env.REACT_APP_AGENTPORTAL_PREFIX}/News`}
              >
                {newsItem.title}
              </SharepointLink>
            </li>
          ))}
        </ul>
      </>
    );
  }
}

function TrainingItems(props) {
  const getToolkitQuery = useQuery({
    queryKey: ['getToolkit', props.baseProductID],
    queryFn: () =>
      GetProductToolkitByCatAndDivList({ Division: '', Product: props.baseProductID })(),
    enabled: false,
  });

  const data = useMemo(() => {
    if (getToolkitQuery.isSuccess && getToolkitQuery.data) {
      return JSON.parse(getToolkitQuery.data);
    }
    return [];
  }, [getToolkitQuery.data]);

  useEffect(() => {
    if (props.baseProductID !== undefined) {
      getToolkitQuery.refetch();
    }
  }, [props.baseProductID]);

  if (getToolkitQuery.isFetching || getToolkitQuery.isPending || props.baseProductID === undefined) {
    return (
      <>
        <ListSkeleton />
      </>
    );
  } else if (!data.length || data.length == 0) {
    return (
      <>
        <h6 className="no-items">No training material available.</h6>
      </>
    );
  } else {
    return (
      <>
        <ul>
          {data.length &&
            data.map((trainingItem, index) => (
              <li key={trainingItem.ID ?? `training-${index}`}>
                <SharepointLink
                  baseUrl={`${process.env.REACT_APP_AGENTPORTAL_PREFIX}/LearningCenter`}
                  linkType={trainingItem.LinkTypeID}
                  link={trainingItem.FormLink}
                  target="blank"
                >
                  {trainingItem.Title}
                </SharepointLink>
              </li>
            ))}
        </ul>
      </>
    );
  }
}

function FormItems(props) {
  return (
    <ul className="forms-items-list">
      {props.appPackageElement[0]}
      <li key={'forms-url-1'} className={props.productDetails == undefined ? 'disabled' : ''}>
        {props.productDetails ? (
          <FormURL product={props.productDetails[props.productIndex].BaseProductId}>
            Forms Ordering
          </FormURL>
        ) : (
          <a>Forms Ordering</a>
        )}
      </li>
      <li key={'forms-url-2'} className={props.productDetails == undefined ? 'disabled' : ''}>
        {props.productDetails ? (
          <FormURL
            product={props.productDetails[props.productIndex].BaseProductId}
            category="Marketing Materials"
          >
            Marketing Materials
          </FormURL>
        ) : (
          <a>Marketing Materials</a>
        )}
      </li>
      <li key={'forms-url-3'} className={props.productDetails == undefined ? 'disabled' : ''}>
        {props.productDetails ? (
          <FormURL
            product={props.productDetails[props.productIndex].BaseProductId}
            category="Agent Reference"
          >
            Agent Reference
          </FormURL>
        ) : (
          <a>Agent Reference</a>
        )}
      </li>
    </ul>
  );
}

function ListSkeleton() {
  return <Skeleton variant="rectangular" className="pl-1" height={'12.5em'} width={'100%'} />;
}

export { useToolkitStore };

export { Index };


